import { ConvertService } from "./ConvertService";

export class EnvService extends ConvertService
{
    name: string;
    constructor(name: string, mandatory: boolean = false)
    {
        super(mandatory);
        this.name = name;
    }
    override getNullString()
    {
        let ans = process.env[this.name];
        if (ans)
            return ans;
        return null;
    }
    protected override onMandatoryError(): void
    {
        if (!process.env.NAMIRASOFT_MUTE)
            throw new Error(`Env value was not provided: ${this.name}`);
    }
}